import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad, Route
} from '@angular/router';
import { ApiService } from './api.service';
import { JWTTokenService } from './jwt.token.service';
import { getAuth } from 'firebase/auth';

@Injectable({
  providedIn: 'root'  // Add this to auto-provide at root injector
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private ApiService: ApiService, private router: Router, private jwtService: JWTTokenService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let url: string = state.url;

    // Check if user is logged in
    if (!this.ApiService.isLoggedin()) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // Check role if needed
    let userRole = this.ApiService.getRole();
    if (route.data?.['role'] && route.data?.['role'].indexOf(userRole) === -1) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // If token is expired, try to refresh
    if (this.jwtService.isTokenExpired()) {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user) {
        try {
          const newToken = await user.getIdToken(true); // Force refresh
          localStorage.setItem('GProToken', JSON.stringify(newToken));
          return true; // Allow access after refresh
        } catch (error) {
          this.handleLogout();
          return false;
        }
      } else {
        this.handleLogout();
        return false;
      }
    }

    // Token is valid
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;
    return true;
  }

  checkUserLogin(route: ActivatedRouteSnapshot, url: string): boolean {
    if (this.ApiService.isLoggedin()) {
      let userRole = this.ApiService.getRole();
      if (route.data?.['role'] && route.data?.['role'].indexOf(userRole) === -1) {
        this.router.navigate(['/auth/login']);
        return false;
      } else {
        return true;
      }
    }
    this.router.navigate(['/auth/login']);
    return false;
  }

  private handleLogout() {
    this.ApiService.isAuthenticatedSrc.next(false);
    localStorage.removeItem('GPROLE');
    localStorage.removeItem('GProToken');
    localStorage.removeItem('GPSTATE');
    localStorage.removeItem('GPFullName');
    localStorage.removeItem('GPPhoneNumber');
    localStorage.removeItem('GPPicture');
    const auth = getAuth();
    auth.signOut().then(() => {
      this.router.navigate(['/auth/login']);
    });
  }
}